import { InjectionToken } from '@angular/core';

export enum RxAppContext {
  RxPhoto = 'rx-photo',
  RxStaff = 'rx-staff',
  RxForms = 'rx-forms',
  RxPortal = 'rx-portal',
}

export const RX_APP_CONTEXT = new InjectionToken<RxAppContext>('RX_APP_CONTEXT', {
  providedIn: 'root',
  factory: () => RxAppContext.RxPhoto,
});
